module.exports = __webpack_public_path__ + "img/myAccountSet.12c42069.png";